const COMMON = {
  checkDevice: function () {
    const varUA = navigator.userAgent.toLowerCase() || ''
    if (varUA.includes('android')) {
      return 'android'
    } else if (varUA.includes('iphone') || varUA.includes('ipad') || varUA.includes('ipod')) {
      return 'ios'
    } else {
      return 'others'
    }
  },
  isMobile: /iphone|ipad|ipod|android/i.test(navigator.userAgent.toLowerCase())
}

export default COMMON
